export const locationIntradaySelectOptions = {
  options: {
    revenueCenterMetrics: {
      defaultId: [['all', 'average_net_sales|price']],
      options: [
        // All revenue centers
        { id: 'all', parentId: 'root', displayName: 'All' },
        {
          id: 'average_net_sales|price',
          parentId: 'all',
          displayName: 'Average Sales',
        },
        {
          id: 'average_check_count|number',
          parentId: 'all',
          displayName: 'Average Check Count',
        },
        {
          id: 'average_labor_cost|price',
          parentId: 'all',
          displayName: 'Labor $',
        },
        {
          id: 'average_labor_hour|number',
          parentId: 'all',
          displayName: 'Average Labor Hours',
        },
        {
          id: 'average_labor_percent|percent',
          parentId: 'all',
          displayName: 'Average Labor %',
        },
        {
          id: 'splh|price',
          parentId: 'all',
          displayName: 'SPLH',
        },
        {
          id: 'average_sales_minus_labor_cost|price',
          parentId: 'all',
          displayName: 'Average Sales $ - Labor $',
        },

        {
          id: 'call_togo',
          parentId: 'root',
          displayName: 'Call-ToGo',
        },
        {
          id: 'average_revenue_center_sales_call_togo|price',
          parentId: 'call_togo',
          displayName: 'Average Sales',
        },
        {
          id: 'average_revenue_center_check_count_call_togo|number',
          parentId: 'call_togo',
          displayName: 'Average Check Count',
        },

        {
          id: 'dd_delivery',
          parentId: 'root',
          displayName: 'DD-Delivery',
        },
        {
          id: 'average_revenue_center_sales_dd_delivery|price',
          parentId: 'dd_delivery',
          displayName: 'Average Sales',
        },
        {
          id: 'average_revenue_center_check_count_dd_delivery|number',
          parentId: 'dd_delivery',
          displayName: 'Average Check Count',
        },

        {
          id: 'dispatch',
          parentId: 'root',
          displayName: 'Dispatch',
        },
        {
          id: 'average_revenue_center_sales_dispatch|price',
          parentId: 'dispatch',
          displayName: 'Average Sales',
        },
        {
          id: 'average_revenue_center_check_count_dispatch|number',
          parentId: 'dispatch',
          displayName: 'Average Check Count',
        },

        {
          id: 'grub_hub',
          parentId: 'root',
          displayName: 'Grub Hub',
        },
        {
          id: 'average_revenue_center_sales_grub_hub|price',
          parentId: 'grub_hub',
          displayName: 'Average Sales',
        },
        {
          id: 'average_revenue_center_check_count_grub_hub|number',
          parentId: 'grub_hub',
          displayName: 'Average Check Count',
        },

        {
          id: 'online',
          parentId: 'root',
          displayName: 'Online',
        },
        {
          id: 'average_revenue_center_sales_online|price',
          parentId: 'online',
          displayName: 'Average Sales',
        },
        {
          id: 'average_revenue_center_check_count_online|number',
          parentId: 'online',
          displayName: 'Average Check Count',
        },

        {
          id: 'uber_eats',
          parentId: 'root',
          displayName: 'Uber Eats',
        },
        {
          id: 'average_revenue_center_sales_uber_eats|price',
          parentId: 'uber_eats',
          displayName: 'Average Sales',
        },
        {
          id: 'average_revenue_center_check_count_uber_eats|number',
          parentId: 'uber_eats',
          displayName: 'Average Check Count',
        },

        {
          id: 'walk_dine_in',
          parentId: 'root',
          displayName: 'Walk Dine In',
        },
        {
          id: 'average_revenue_center_sales_walk_dine_in|price',
          parentId: 'walk_dine_in',
          displayName: 'Average Sales',
        },
        {
          id: 'average_revenue_center_check_count_walk_dine_in|number',
          parentId: 'walk_dine_in',
          displayName: 'Average Check Count',
        },

        {
          id: 'walk_togo',
          parentId: 'root',
          displayName: 'Walk-ToGo',
        },
        {
          id: 'average_revenue_center_sales_walk_togo|price',
          parentId: 'walk_togo',
          displayName: 'Average Sales',
        },
        {
          id: 'average_revenue_center_check_count_walk_togo|number',
          parentId: 'walk_togo',
          displayName: 'Average Check Count',
        },
      ],
    },
    dayOfWeek: {
      defaultId: [
        ['dow7'],
        ['dow1'],
        ['dow2'],
        ['dow3'],
        ['dow4'],
        ['dow5'],
        ['dow6'],
      ],
      options: [
        { id: 'dow7', parentId: 'root', displayName: 'Sunday' },
        { id: 'dow1', parentId: 'root', displayName: 'Monday' },
        { id: 'dow2', parentId: 'root', displayName: 'Tuesday' },
        { id: 'dow3', parentId: 'root', displayName: 'Wednesday' },
        { id: 'dow4', parentId: 'root', displayName: 'Thursday' },
        { id: 'dow5', parentId: 'root', displayName: 'Friday' },
        { id: 'dow6', parentId: 'root', displayName: 'Saturday' },
      ],
    },
    hours: {
      defaultId: [
        ['hour2300'],
        ['hour2400'],
        ['hour2500'],
        ['hour2600'],
        ['hour2700'],
      ],
      options: [
        // All hours
        { id: 'hour500', parentId: 'root', displayName: '5am-6am' },
        { id: 'hour600', parentId: 'root', displayName: '6am-7am' },
        { id: 'hour700', parentId: 'root', displayName: '7am-8am' },
        { id: 'hour800', parentId: 'root', displayName: '8am-9am' },
        { id: 'hour900', parentId: 'root', displayName: '9am-10am' },
        { id: 'hour1000', parentId: 'root', displayName: '10am-11am' },
        { id: 'hour1100', parentId: 'root', displayName: '11am-12pm' },
        { id: 'hour1200', parentId: 'root', displayName: '12pm-1pm' },
        { id: 'hour1300', parentId: 'root', displayName: '1pm-2pm' },
        { id: 'hour1400', parentId: 'root', displayName: '2pm-3pm' },
        { id: 'hour1500', parentId: 'root', displayName: '3pm-4pm' },
        { id: 'hour1600', parentId: 'root', displayName: '4pm-5pm' },
        { id: 'hour1700', parentId: 'root', displayName: '5pm-6pm' },
        { id: 'hour1800', parentId: 'root', displayName: '6pm-7pm' },
        { id: 'hour1900', parentId: 'root', displayName: '7pm-8pm' },
        { id: 'hour2000', parentId: 'root', displayName: '8pm-9pm' },
        { id: 'hour2100', parentId: 'root', displayName: '9pm-10pm' },
        { id: 'hour2200', parentId: 'root', displayName: '10pm-11pm' },
        { id: 'hour2300', parentId: 'root', displayName: '11pm-12am' },
        { id: 'hour2400', parentId: 'root', displayName: '12am-1am' },
        { id: 'hour2500', parentId: 'root', displayName: '1am-2am' },
        { id: 'hour2600', parentId: 'root', displayName: '2am-3am' },
        { id: 'hour2700', parentId: 'root', displayName: '3am-4am' },
        { id: 'hour2800', parentId: 'root', displayName: '4am-5am' },
      ],
    },
  },
}

export function getRevenueCenterMetricDisplayName(metricId: string) {
  const allRevenueCenterOptions =
    locationIntradaySelectOptions.options.revenueCenterMetrics.options
  const selectedOption = allRevenueCenterOptions.find(
    (option) => option.id === metricId,
  )
  return selectedOption?.displayName || ''
}
